module.exports = __webpack_public_path__ + "static/media/question.55abe2e2.png";